import Amount from "components/v2/Amount/Amount";
import usePermissions from "hooks/usePermissions";
import { formatPriceV2 } from "helpers/commonHelpers";
import { useGetQuotationConsts } from "../../helpers/ShipmentQuotesV2Helpers";

interface QuotationCostsProps {
  quotation: any;
  trafficLightBuckets?: ReturnType<typeof useGetQuotationConsts>["trafficLightBuckets"];
}

export default function QuotationCosts({ quotation, trafficLightBuckets }: QuotationCostsProps) {
  const { permissions } = usePermissions();
  const traffic_light_enabled = JSON.parse(permissions || "{}")?.company_shipper_settings?.traffic_light_detail
    ?.traffic_light_enabled;

  const { financial, service, status } = quotation;
  const {
    total_quoted_amount,
    total_quoted_amount_currency,
    client_price_per_mile,
    client_price_per_km,
    total_quoted_amount_usd,
  } = financial || {};

  const { freight_mode_label } = service;
  const {
    totalQuotes: totalQuotesInTrafficLightBucket,
    lowerMarginUSD,
    upperMarginUSD,
  } = trafficLightBuckets?.[freight_mode_label] ?? {};

  const renderTrafficLight =
    traffic_light_enabled &&
    (totalQuotesInTrafficLightBucket ?? 0) > 1 &&
    !["canceled", "canceled_by_provider"].includes(status);

  const trafficLightColor = (() => {
    if (!renderTrafficLight || !lowerMarginUSD || !upperMarginUSD) return null;
    if (total_quoted_amount_usd < lowerMarginUSD) return "bg-mustard-yellow";
    if (total_quoted_amount_usd >= lowerMarginUSD && total_quoted_amount_usd <= upperMarginUSD) return "bg-mustard-yellow";
    if (total_quoted_amount_usd > upperMarginUSD) return "bg-peach-red";
    return null;
  })();

  return (
    <div>
      <div className="d-flex align-items-center justify-content-end">
        {renderTrafficLight && (
          <div
            className={`${trafficLightColor} mr-sm`}
            style={{
              width: "6px",
              height: "6px",
              borderRadius: "50%",
            }}
          />
        )}
        <Amount amount={total_quoted_amount ?? 0} currency={total_quoted_amount_currency ?? 0} size="lg" />
      </div>
      <div className="d-flex justify-content-end text-tertiary">
        {client_price_per_mile && (
          <div>
            <div>
              {`${formatPriceV2(client_price_per_mile)} ${total_quoted_amount_currency}`}
              <span className="mx-xxs">/</span>
              mile
            </div>
          </div>
        )}

        {client_price_per_mile && client_price_per_km && <div className="mx-sm"> | </div>}

        {client_price_per_km && (
          <div>
            <div>
              {`${formatPriceV2(client_price_per_km)} ${total_quoted_amount_currency}`}
              <span className="mx-xxs">/</span>
              km
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

QuotationCosts.defaultProps = {
  trafficLightBuckets: undefined,
};
